export const CONTRACT_TYPES = {
  customer: {
    id: 'customer',
    label: 'Customer Contracts',
    sublabel: 'B2B logistics service agreements',
  },
  transport: {
    id: 'transport',
    label: 'Transport Contracts',
    sublabel: 'Third-party carrier partnerships',
  },
  tankLease: {
    id: 'tankLease',
    label: 'Tank Lease Contracts',
    sublabel: 'ISO & depot tank leasing',
  },
  driverEmployment: {
    id: 'driverEmployment',
    label: 'Driver Employment Contracts',
    sublabel: 'HSE-compliant employment terms',
  },
  insurance: {
    id: 'insurance',
    label: 'Insurance Policies',
    sublabel: 'Fleet, cargo & liability coverage',
  },
};

export const SLA_TIERS = {
  platinum: { label: 'Platinum', className: 'bg-logi-accent/10 text-logi-accent ring-violet-500/25' },
  gold: { label: 'Gold', className: 'bg-amber-50 text-amber-700 ring-amber-500/25' },
  silver: { label: 'Silver', className: 'bg-white text-logi-muted ring-logi-grid' },
  standard: { label: 'Standard', className: 'bg-logi-accent/100/10 text-blue-700 ring-blue-500/25' },
  enterprise: { label: 'Enterprise', className: 'bg-logi-accent/10 text-logi-accent ring-logi-accent/30' },
  premium: { label: 'Premium', className: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25' },
};

const REFERENCE_DATE = new Date('2026-06-12');

export function daysUntilExpiry(expiryDate) {
  const expiry = new Date(expiryDate);
  return Math.floor((expiry - REFERENCE_DATE) / (1000 * 60 * 60 * 24));
}

export function computeAlertStatus(expiryDate) {
  const days = daysUntilExpiry(expiryDate);

  if (days < 0) {
    return {
      level: 'expired',
      label: 'Expired',
      hint: `${Math.abs(days)}d overdue`,
      className: 'bg-red-500/15 text-red-700 ring-red-500/35',
      dotClass: 'bg-red-500',
    };
  }
  if (days < 30) {
    return {
      level: 'critical',
      label: 'Critical',
      hint: `${days}d remaining`,
      className: 'bg-red-500/15 text-red-700 ring-red-500/35',
      dotClass: 'bg-red-500',
    };
  }
  if (days < 90) {
    return {
      level: 'warning',
      label: 'Renewal Due',
      hint: `${days}d remaining`,
      className: 'bg-amber-500/15 text-amber-700 ring-amber-500/35',
      dotClass: 'bg-amber-500',
    };
  }
  return {
    level: 'active',
    label: 'Active',
    hint: `${days}d remaining`,
    className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/35',
    dotClass: 'bg-emerald-500',
  };
}

export const ALL_CONTRACTS = [
  // Customer
  { id: 'CC-2024-001', type: 'customer', partyName: 'Emirates National Oil Co.', slaTier: 'platinum', startDate: '2024-01-15', expiryDate: '2027-01-14', status: 'active' },
  { id: 'CC-2024-008', type: 'customer', partyName: 'ADNOC Distribution', slaTier: 'enterprise', startDate: '2024-06-01', expiryDate: '2026-08-01', status: 'active' },
  { id: 'CC-2025-003', type: 'customer', partyName: 'Gulf Petrochemical Industries', slaTier: 'gold', startDate: '2025-03-10', expiryDate: '2026-07-05', status: 'active' },
  { id: 'CC-2023-012', type: 'customer', partyName: 'Dubai Petroleum Corp.', slaTier: 'silver', startDate: '2023-05-20', expiryDate: '2026-05-01', status: 'active' },
  // Transport
  { id: 'TC-2024-004', type: 'transport', partyName: 'Al Maha Transport LLC', slaTier: 'gold', startDate: '2024-02-01', expiryDate: '2027-02-28', status: 'active' },
  { id: 'TC-2025-001', type: 'transport', partyName: 'Desert Haulage FZE', slaTier: 'standard', startDate: '2025-01-15', expiryDate: '2026-07-20', status: 'active' },
  { id: 'TC-2024-011', type: 'transport', partyName: 'Gulf Tanker Services', slaTier: 'silver', startDate: '2024-09-01', expiryDate: '2026-09-15', status: 'active' },
  { id: 'TC-2023-007', type: 'transport', partyName: 'Musaffah Logistics Co.', slaTier: 'standard', startDate: '2023-11-10', expiryDate: '2026-06-25', status: 'active' },
  // Tank Lease
  { id: 'TL-2024-002', type: 'tankLease', partyName: 'Jebel Ali Tank Leasing', slaTier: 'enterprise', startDate: '2024-04-01', expiryDate: '2027-04-30', status: 'active' },
  { id: 'TL-2025-005', type: 'tankLease', partyName: 'Fujairah ISO Container Hub', slaTier: 'gold', startDate: '2025-02-15', expiryDate: '2026-08-10', status: 'active' },
  { id: 'TL-2024-009', type: 'tankLease', partyName: 'Ruwais Depot Holdings', slaTier: 'platinum', startDate: '2024-07-01', expiryDate: '2026-06-28', status: 'active' },
  // Driver Employment
  { id: 'DE-2025-014', type: 'driverEmployment', partyName: 'Ahmed Al Mansouri', slaTier: 'standard', startDate: '2025-04-01', expiryDate: '2027-03-31', status: 'active' },
  { id: 'DE-2024-022', type: 'driverEmployment', partyName: 'Rajesh Kumar', slaTier: 'standard', startDate: '2024-08-15', expiryDate: '2026-07-01', status: 'active' },
  { id: 'DE-2025-008', type: 'driverEmployment', partyName: 'Mohammed Hassan', slaTier: 'premium', startDate: '2025-01-10', expiryDate: '2026-09-30', status: 'active' },
  { id: 'DE-2023-031', type: 'driverEmployment', partyName: 'Sanjay Patel', slaTier: 'standard', startDate: '2023-12-01', expiryDate: '2026-06-01', status: 'active' },
  // Insurance
  { id: 'IN-2025-001', type: 'insurance', partyName: 'Oman Insurance · Fleet Cover', slaTier: 'premium', startDate: '2025-01-01', expiryDate: '2027-01-01', status: 'active' },
  { id: 'IN-2025-004', type: 'insurance', partyName: 'AXA Gulf · Cargo Liability', slaTier: 'enterprise', startDate: '2025-04-01', expiryDate: '2026-07-15', status: 'active' },
  { id: 'IN-2024-009', type: 'insurance', partyName: 'RSA Insurance · Hazmat Policy', slaTier: 'platinum', startDate: '2024-06-01', expiryDate: '2026-08-20', status: 'active' },
  { id: 'IN-2024-003', type: 'insurance', partyName: 'National General · Third Party', slaTier: 'gold', startDate: '2024-03-15', expiryDate: '2026-06-18', status: 'active' },
];

export function getContractsByType(type) {
  return ALL_CONTRACTS.filter((c) => c.type === type);
}

export function computeContractSummary(contracts = ALL_CONTRACTS) {
  const activeContracts = contracts.filter((c) => c.status === 'active');
  const alerts = { critical: 0, warning: 0, active: 0, expired: 0 };

  activeContracts.forEach((c) => {
    const status = computeAlertStatus(c.expiryDate);
    alerts[status.level === 'critical' ? 'critical' : status.level]++;
  });

  return {
    total: contracts.length,
    activeCount: activeContracts.length,
    terminated: contracts.filter((c) => c.status === 'terminated').length,
    ...alerts,
    urgent: alerts.critical + alerts.expired,
  };
}

export const CONTRACT_STATUS = {
  active: {
    label: 'Active',
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
  },
  terminated: {
    label: 'Terminated',
    className: 'bg-white text-logi-muted ring-logi-grid',
  },
};

export const CONTRACT_ID_PREFIX = {
  customer: 'CC',
  transport: 'TC',
  tankLease: 'TL',
  driverEmployment: 'DE',
  insurance: 'IN',
};

export const EMPTY_CONTRACT_FORM = {
  partyName: '',
  slaTier: 'standard',
  startDate: '',
  expiryDate: '',
};

export function generateContractId(type, contracts) {
  const prefix = CONTRACT_ID_PREFIX[type];
  const year = new Date().getFullYear();
  const sameType = contracts.filter((c) => c.type === type);
  const nums = sameType.map((c) => parseInt(c.id.split('-').pop(), 10));
  const next = Math.max(0, ...nums) + 1;
  return `${prefix}-${year}-${String(next).padStart(3, '0')}`;
}

export function extendExpiryByOneYear(expiryDate) {
  const d = new Date(expiryDate);
  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().slice(0, 10);
}

export function todayDateString() {
  return new Date().toISOString().slice(0, 10);
}
